import { motion } from 'motion/react'

type Props = {
  label: string
  value: number
  max?: number
}

export function NeedBar({ label, value, max = 100 }: Props) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100))
  const color =
    pct < 20
      ? 'bg-red-600'
      : pct < 40
        ? 'bg-amber-500'
        : 'bg-emerald-600'

  return (
    <div className="flex items-center gap-2">
      <span className="w-12 shrink-0 text-[10px] uppercase tracking-wider text-stone-400">
        {label}
      </span>
      <div className="relative h-2 flex-1 overflow-hidden rounded-sm bg-stone-800 ring-1 ring-inset ring-stone-700">
        <motion.div
          className={`h-full ${color}`}
          animate={{ width: `${pct}%` }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      </div>
      <span className="w-8 shrink-0 text-right font-mono text-[10px] text-stone-400">
        {Math.round(value)}
      </span>
    </div>
  )
}
